import React, {Component} from 'react'
import Image from 'shared/image';
import Link from 'shared/link';
import parse from 'html-react-parser';
import style from './mastheadSpecialtyBasic.module.scss';

class Masthead extends Component {
	render() {
		var title = '';
		if (this.props.title) {
			title = this.props.title;
		}
		var intro = '';
		if (this.props.intro) {
			intro = this.props.intro;
		}
		return (
			<section className={style.wrapper} style={{'backgroundColor':this.props.background ? this.props.background : 'rgb(255,255,255)'}}>
				<div className={[style.container, "grid-container"].join(' ')}>
					<div className="grid-x">
						<div className={[this.props.sidebar || this.props.sidebarImage  ? 'medium-7' : 'medium-10 medium-offset-1', "cell"].join(' ')}>
							<h1 className={style.title}>{this.props.name}</h1>
							<div className={style.body}>
								{this.props.description ? parse(this.props.description) : ''}
							</div>
						</div>
						<div className={[this.props.sidebar || this.props.sidebarImage ? 'cell medium-offset-1 medium-4' : 'hide'].join(' ')}>
							<div className={this.props.sidebarImage ? style.sidebarImage : style.sidebarContainer}>
								{this.props.sidebarImage ? <Image src={this.props.sidebarImage} /> : this.props.sidebar ? parse(this.props.sidebar) : ''}
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default Masthead;